import { useState } from 'react'

import { meetingApi } from '../api'

const useStartRecording = () => {
  const [isStarting, setIsStarting] = useState(false)

  const startRecording = async (meetingId: string) => {
    setIsStarting(true)

    try {
      const meeting = await meetingApi.startRecording(meetingId)
      return meeting
    } catch (error) {
      console.error('Failed to start recording', error)
    } finally {
      setIsStarting(false)
    }
  }

  return { isStarting, startRecording }
}

export default useStartRecording
